/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".questionText[_ngcontent-%COMP%] {\n  font-weight: bold;\n  color: #26266B; }\n\n.infoLabel[_ngcontent-%COMP%] {\n  font-size: 0.8rem !important; }"];
export { styles as styles };
